import {ListPresenter} from "../../routing/ListPresenter";
import * as ts from "../../common/Translator";
import {EntityListPlace} from "../../routing/places";
import {BaseWidget} from "../../widgets/BaseWidget";
import {gridSizeToPixels} from "../../common/GUIUtilities";
import * as ViewMode from "../../constants/ViewMode";
import {shouldShowIds} from "../../login/ClientCache";

export class EmbeddedListView extends BaseWidget {

    constructor(req, listViewId, listViewEntityType) {
        super(req);
        let that = this;
        /**
         * @type {namaTypes.EditScreenList}
         */
        that.block = req.block;
        that.relatedEditPresenter = req.editPresenter;
        that.started = false;
        that.listViewId = listViewId;
        that.listViewEntityType = listViewEntityType;
        that.dialogBox = req.dialogBox;
        if (req.editPresenter && that.block.sourceField && that.block.sourceField.length)
            req.editPresenter.addOnChangeListener(that.block.sourceField.split(","), () => that.setValue());
    }

    createElement(style) {
        return $(`<ul id = ${this.elementId} class=${this.listViewId_()}></ul>`);
    }

    shouldAddBlurHandler() {
        return false;
    }

    readFromServer() {
        let that = this;
        if (!that.started)
            return;
        let lastRecordId = that.relatedEditPresenter.record.id;
        let forceInitPresenter = false;
        if (that.relatedEditPresenter.place.view === ViewMode.NEW)
            forceInitPresenter = true;
        let currentRecordId = that.listPresenter ? that.listPresenter.embeddedListViewSrcRecord.id : null;
        if (lastRecordId !== currentRecordId || forceInitPresenter)
            that.listPresenter = null;
        if (that.listPresenter) {
            that.listPresenter.onRefresh();
        } else {
            that.initListPresenter();
            that.listPresenter.start();
        }
    }

    initListPresenter() {
        let that = this;
        if (that.listPresenter)
            return;
        that.findElement().find("#content").html("");
        that.listPlace = new EntityListPlace();
        that.listPlace.entityType = that.listViewEntityType_();
        that.listPlace.listViewName = that.listViewId_();
        that.listPresenter = new ListPresenter(that.listPlace);
        that.listPresenter.onLayoutFetched = (layout) => {
            that.onLayoutFetched(layout);
        };
        that.listPresenter.embeddedListLayoutWrapper = that.findElement().find("#content");
        that.listPresenter.embeddedListMetaData = that.owner.metaData;
        that.listPresenter.block = that.block;
        that.listPresenter.embeddedListViewSrcRecord = that.relatedEditPresenter.record;
        that.listPresenter.wrapperHeight = gridSizeToPixels(that.block.size);
        that.listPresenter.dialogBox = that.dialogBox;

    }

    /**
     *
     * @param layout {namaTypes.ListScreenLayout}
     */
    onLayoutFetched(layout) {
        this.queriedClass = "";
        if (layout.queriedClass)
            this.queriedClass = layout.queriedClass.split(".").pop();
        this.objectName = layout.objectName;
        $("#" + this.elementId + "Span").append(this.concatTextIfFieldNotNull(", Object Name: ", this.objectName) + this.concatTextIfFieldNotNull(", Object Class: ", this.queriedClass));
    }

    setValue() {
        let panelbar = this.findElement().data("kendoPanelBar");
        if (this.findElement().find("#content").parent().attr("aria-hidden") === "true")
            return;
        this.readFromServer();
    }

    concatTextIfFieldNotNull(prefix, fieldValue) {
        if (fieldValue)
            return prefix + fieldValue;
        return "";
    }

    afterAttach() {
        let that = this;
        let panelBar = that.findElement().kendoPanelBar({
            select: function (e) {
                that.started = true;
                that.readFromServer();
            }
        }).data("kendoPanelBar");
        let widgetHeight = gridSizeToPixels(that.block.size);


        if (shouldShowIds())
            panelBar.append([{
                "text": `<span id="${that.elementId}Span"> Owner Entity Type : ${that.block.listViewEntityType} , Question Field Id : ${that.block.linkFieldId} , List View Id : ${that.block.listViewId}</span>`
                , encoded: false
                , content: `<div id="content" style="height: ${widgetHeight}px">Please wait</div>`
            }]);
        else {
            panelBar.append([{
                "text": ts.translateNaMaText(that.block.title) || ts.translateId(that.block.id) || ts.translateId(that.listViewId),
                content: `<div id="content" style="height: ${widgetHeight}px">Please wait</div>`
            }]);
        }
        that.listPresenter = null;
    }

    listViewId_() {
        let that = this;
        return that.block.listViewId || that.listViewId;
    }

    listViewEntityType_() {
        let that = this;
        return that.block.listViewEntityType || that.listViewEntityType;
    }
}